module.exports = __webpack_public_path__ + "media/images/drag-icon-9ac941244c476860cc26f4e8e9c2c7e7.svg";